module.exports = __webpack_public_path__ + "assets/img/14.f3f81a53.png";